import React from 'react'
import {Trans} from 'react-i18next'

import {Box, Typography} from '@mui/material'

import AppointmentCard from '@progyny/pages/Consultations/components/AppointmentCard'
import {
  formatAppointmentDate,
  formatAppointmentTime,
} from '@progyny/utils/appointmentHelpers'

export interface SessionItem {
  sessionIndex: string
  title: string
  subtitle: string
  description: string
  status: string
  appointment: any
  required: boolean
}

export interface UpcomingSessionsProps {
  sessions: SessionItem[]
  colors?: any
  programSlug?: string
  t: (key: string) => string
  onCancelRequested?: (cancelUrl: string) => void
}

const UpcomingSessions: React.FC<UpcomingSessionsProps> = ({
  sessions,
  colors,
  programSlug,
  t,
  onCancelRequested,
}) => {
  if (sessions.length === 0) {
    return (
      <Box>
        <Typography>
          <Trans i18nKey='consultations_program_upcoming_sessions_no_upcoming_sessions' />
        </Typography>
      </Box>
    )
  }

  return (
    <Box>
      {sessions.map((session, index) => (
        <AppointmentCard
          key={index}
          status='upcoming'
          session={`${t('common_session')} ${session.sessionIndex}`}
          title={session.title}
          subtitle={session.subtitle || ''}
          date={formatAppointmentDate(session.appointment?.scheduledTime)}
          time={formatAppointmentTime(session.appointment?.scheduledTime)}
          description={session.description}
          colors={colors}
          programSlug={programSlug}
          sessionNumber={Number(session.sessionIndex)}
          appointment={session.appointment}
          canJoin={session?.appointment?.canJoin}
          meetingLink={session?.appointment?.meetingLink}
          onCancelRequested={onCancelRequested}
        />
      ))}
    </Box>
  )
}

export default UpcomingSessions
